module.exports = __webpack_public_path__ + "img/img2.9d42cbe1.png";